import Env from "../../base/env";
import Channels from "../../base/channels";
import Component from "gia/Component";
import gsap from "gsap";
import { SlowMo } from "../../vendor/gsap-bonus-umd/EasePack";
import { ScrollTrigger } from "../../vendor/gsap-bonus-umd/ScrollTrigger";
import { Draggable } from "../../vendor/gsap-bonus-umd/Draggable";
import { InertiaPlugin } from "../../vendor/gsap-bonus-umd/InertiaPlugin";
gsap.registerPlugin(SlowMo, ScrollTrigger, Draggable, InertiaPlugin);

export default class Module extends Component {
  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.loopItems = this.DOM.view.querySelectorAll(".js-item");
    if (this.DOM.loopItems.length == 0) return false;
    this.DOM.loopItemsAll = this.DOM.view.querySelectorAll(".js-item-all");
    this.DOM.getLast = this.DOM.loopItems[this.DOM.loopItems.length - 1];
    this.DOM.getLastAll =
      this.DOM.loopItemsAll[this.DOM.loopItemsAll.length - 1];

    //! VARS
    this.INVERT =
      typeof this.DOM.view.getAttribute("data-invert") != "undefined" &&
      this.DOM.view.getAttribute("data-invert") == 1
        ? true
        : false;
    this.RAF = false;
    this.MOVING_X = 0;
    this.SPEED = Env.mobileCSS ? 0.2 : 1;
    this.SCROLL_SPEED = 0;
    this.CAN_START = false;
    this.LISTEN_SCROLL = false;
    this.INIT = false;
    this.PAUSED = false;
    this.DRAGGING = false;
    //! FNs
    this.funcResize = this.resize.bind(this);
    this.funcStart = this.start.bind(this);
    Channels.on("window::smartresize", this.funcResize);
    this.resize();
    this.setStartPosition();
    this.watcher();
    this._fx();
    this.events();
    this.makeDraggableProxy();
  }

  _fx() {
    this.reveal();
  }

  makeDraggableProxy() {
    this.proxy = document.createElement("div");
    gsap.set(this.proxy, { x: "+=-999999px" });

    this.draggable = new Draggable(this.proxy, {
      trigger: this.DOM.loopItemsAll,
      inertia: true,
      onDragStart: () => {
        this.DRAGGING = true;
      },
      onDrag: () => {
        this.moveAction();
      },
      onThrowUpdate: () => {
        this.moveAction();
      },
      onThrowComplete: () => {
        this.DRAGGING = false;
      },
    });
  }

  moveAction() {
    let t = gsap.getProperty(this.proxy, "x");
    if (t > 0) {
      gsap.set(this.proxy, { x: "+=-999999px" });
    }
    t = gsap.getProperty(this.proxy, "x");
    this.MOVING_X = t % this.MOVE_X_LIMIT;
  }

  events() {
    for (let item of this.DOM.loopItemsAll) {
      item.addEventListener("mouseenter", () => {
        this.PAUSED = true;
      });
      item.addEventListener("mouseleave", () => {
        this.PAUSED = false;
      });
    }
  }

  resize() {
    const viewport = Env.framework.toolbox.getViewport();
    this.COORDS = this.DOM.getLast.getBoundingClientRect();
    // this.MOVE_X_LIMIT = ((this.COORDS.width + this.COORDS.x) - viewport.width) * -1
    this.MOVE_X_LIMIT = (this.COORDS.width + this.COORDS.x) * -1;
  }

  reveal() {
    this.st = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: "top 60%",
      onEnter: () => {
        if (this.INIT == false) {
          this.start();
          setTimeout(() => {
            this.listenScroll();
          }, 500);
          this.INIT = true;
        }
      },
    });
  }

  listenScroll() {
    this.LISTEN_SCROLL = true;
  }

  start() {
    this.CAN_START = true;
  }

  setStartPosition() {
    this.MOVING_X = this.MOVE_X_LIMIT / 1.3;
  }

  watcher() {
    this.RAF = requestAnimationFrame(() => {
      if (
        this.CAN_START == true &&
        this.PAUSED == false &&
        this.DRAGGING == false
      ) {
        //? get scroll speed
        // if(typeof Env.smoothInstance != 'undefined' && this.LISTEN_SCROLL) {
        //   this.SCROLL_SPEED = Env.smoothInstance.getVelocity() / 100
        // }
        let currentSpeed = this.SPEED + Math.abs(this.SCROLL_SPEED);

        //? set direction
        if (
          typeof Env.smoothInstance != "undefined" &&
          typeof Env.smoothInstance.scrollTrigger.direction != "undefined"
        ) {
          if (Env.smoothInstance.scrollTrigger.direction == 1) {
            if (this.INVERT == true) {
              this.MOVING_X += currentSpeed;
            } else {
              this.MOVING_X -= currentSpeed;
            }
          } else {
            if (this.INVERT == true) {
              this.MOVING_X -= currentSpeed;
            } else {
              this.MOVING_X += currentSpeed;
            }
          }
        } else {
          if (this.INVERT == true) {
            this.MOVING_X += currentSpeed;
          } else {
            this.MOVING_X -= currentSpeed;
          }
        }

        //? set limit
        // this.MOVING_X = this.MOVING_X % this.MOVE_X_LIMIT
        //? set limit
        if (this.MOVING_X <= this.MOVE_X_LIMIT) {
          this.MOVING_X = 0;
        } else if (this.MOVING_X >= 0) {
          this.MOVING_X = this.MOVE_X_LIMIT;
        }
      }
      gsap.set(this.proxy, { x: this.MOVING_X });
      gsap.set(this.DOM.loopItemsAll, {
        x: this.MOVING_X,
        force3D: true,
        z: 0,
      });
      //? render
      this.watcher();
    });
  }

  unmount() {
    if (this.DOM.loopItems.length > 0) {
      Channels.removeListener("window::smartresize", this.funcResize);
      Channels.removeListener("cover::finalize", this.funcStart);
      cancelAnimationFrame(this.RAF);
      this.st.kill(true);
      this.draggable.kill();
    }
  }
}
